import { useRef } from 'react';
import { Button } from '@chakra-ui/react';
import useDialogCleanup from '@/lib/hooks/use-dialog-cleanup';
import {
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogRoot,
  DialogTitle,
} from '@/components/ui/dialog';

interface Props {
  isOpen: boolean;
  onCancel(): void;
  onConfirm?(): void;
  isLoading?: boolean;
  title: string;
  children: React.ReactNode;
  confirmText?: string;
  confirmForm?: string;
}

export default function DestructiveModal({
  isOpen,
  onCancel,
  onConfirm,
  isLoading = false,
  title,
  children,
  confirmText = 'Delete',
  confirmForm,
}: Props) {
  useDialogCleanup(isOpen);
  const cancelRef = useRef<HTMLButtonElement>(null);

  return (
    <DialogRoot open={isOpen} onOpenChange={onCancel}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>

        <DialogBody>{children}</DialogBody>

        <DialogFooter>
          <Button ref={cancelRef} onClick={onCancel} variant={'ghost'}>
            Cancel
          </Button>
          <Button
            variant='danger'
            loading={isLoading}
            form={confirmForm}
            type={confirmForm ? 'submit' : undefined}
            onClick={onConfirm}
          >
            {confirmText}
          </Button>
        </DialogFooter>
      </DialogContent>
    </DialogRoot>
  );
}
